'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styles = require('./styles.js');
var index = require('../StyledMarkup/index.js');
var StyledThemeProvider = require('../../providers/StyledThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SelectListButton = _ref => {
  let {
    onChange,
    option: {
      value,
      label
    },
    selection
  } = _ref;
  const handleClick = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(styles.SelectListOptionStyled, {
    key: value,
    onClick: () => handleClick(value),
    selected: selection === value
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    content: label
  }));
};
const SelectListC = _ref2 => {
  let {
    options,
    onChange,
    selection
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(styles.SelectListStyled, null, options.map(option => /*#__PURE__*/React__default["default"].createElement(SelectListButton, {
    option,
    onChange,
    selection,
    key: option.value
  })));
};
const SelectList = StyledThemeProvider.withStyledThemeProvider(SelectListC, {
  themeTokens: ['bodytextDefaultNone']
});

exports.SelectList = SelectList;
